import * as React from 'react';

import FileViewer from '../../../guideMessaging/components/FileViewer';

export default function FileViewerScreen() {
    return <FileViewer />;
}
